// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './firebase';
import Vue from 'vue';
import router from './router';
import { firestorePlugin } from 'vuefire';
import vueHeadful from 'vue-headful';
import VModal from 'vue-js-modal';

const App = () => import('./App.vue');

Vue.config.productionTip = false;

Vue.use(firestorePlugin);
Vue.use(VModal);
Vue.component('vue-headful', vueHeadful);

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',

  created() {
    const html = document.documentElement; // returns the html tag
    html.setAttribute('lang', 'fr');
  },
});
